import { useEffect, useState } from 'react';
import { Modal, Input, Button, message } from 'antd';
import './index.less';

const TransmitComSpace = (props: any) => {
  const { handleTransOK, handleTransCancel, ownerInfo, setOwnerInfo } = props;

  // ****生命周期****
  console.log('prop', props);
  useEffect(() => {
    console.log('组件启动', props);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // 输入框的内容
  const [inputPhoneStatus, setInputPhoneStatus] = useState('');
  const [inputNameStatus, setInputNameStatus] = useState('');
  const onInputPhone = (e: any) => {
    console.log('输入手机号', e.target.value);
    const phoneReg = /^1[0-9]{10}$/;
    if (phoneReg.test(e.target.value) === false || e.target.value === '') {
      // 手机号进行正则校验
      setInputPhoneStatus('error');
    } else {
      setInputPhoneStatus('');
      setOwnerInfo({
        ...ownerInfo,
        ownerPhone: e.target.value,
      });
    }
  };

  const [okStatus, setOkStatus] = useState(false);
  const onInputName = (e: any) => {
    if (e.target.value === '') {
      setInputNameStatus('error');
      setOkStatus(false);
    } else {
      setInputNameStatus('');
      setOwnerInfo({
        ...ownerInfo,
        ownerName: e.target.value,
      });
      setOkStatus(true);
    }
    if (e.target.value.length === 50) {
      message.warning('企业拥有者姓名最多填写50个字符');
    }
    console.log('输入名字', e.target.value);
  };

  return (
    <>
      <Modal
        title="转移企业空间"
        visible={true}
        onOk={() => handleTransOK()}
        onCancel={handleTransCancel}
        width={600}
        keyboard={true}
        footer={
          okStatus
            ? [
                <Button onClick={handleTransCancel}>取消</Button>,
                <Button type="primary" onClick={() => handleTransOK()}>
                  确定
                </Button>,
              ]
            : [
                <Button onClick={handleTransCancel}>取消</Button>,
                <Button type="primary" onClick={() => handleTransOK()} disabled>
                  确定
                </Button>,
              ]
        }
      >
        <div className="mention" style={{ width: 600 }}>
          将企业空间拥有权限转移给其他人
        </div>
        <div
          className="modalContent inputUserName"
          style={{ marginBottom: 20, paddingTop: '60px', height: '108px' }}
        >
          <div className="inputLabel" style={{ width: 150 }}>
            {' '}
            企业拥有者手机号{' '}
          </div>
          <div className="modalInput" style={{ width: 300 }}>
            <Input
              placeholder="输入拥有者手机号"
              onChange={onInputPhone}
              status={inputPhoneStatus === 'error' ? inputPhoneStatus : undefined}
              maxLength={11}
            />
            {inputPhoneStatus === 'error' ? (
              <div className="inputMention" style={{ color: '#ff4d4f', fontSize: '12px' }}>
                手机号格式错误
              </div>
            ) : (
              <></>
            )}
          </div>
        </div>
        <div className="modalContent inputPhoneCall" style={{ marginBottom: 20, height: 48 }}>
          <div className="inputLabel" style={{ width: 150 }}>
            {' '}
            企业拥有者姓名{' '}
          </div>
          <div className="modalInput" style={{ width: 300 }}>
            <Input
              placeholder="输入拥有者姓名"
              onChange={onInputName}
              status={inputNameStatus === 'error' ? inputNameStatus : undefined}
              maxLength={50}
            />
            {inputNameStatus === 'error' ? (
              <div className="inputMention" style={{ color: '#ff4d4f', fontSize: '12px' }}>
                请输入拥有者姓名
              </div>
            ) : (
              <></>
            )}
          </div>
        </div>
      </Modal>
    </>
  );
};
export default TransmitComSpace;
